import { useAppRouteState } from "@/app/app/_/routing";
import { getSelectedViewId } from "@/app/app/_/views/ReportsView/ReportsView.utils";
import { UtilityBar } from "@/components/organisms/UtilityBar";
import { State } from "@/state";

/** Utility bar shown on the reports list (no view selected). */
export function ReportsViewSubnav() {
  const routeState = useAppRouteState();
  const activeTab = State((state) => state.activeTab);
  const activeTabNodeIds = State((state) => state.activeTabNodeIds);
  const selectedViewId = getSelectedViewId(
    activeTabNodeIds,
    activeTab,
    routeState.viewId,
  );

  if (selectedViewId) {
    return null;
  }

  return <UtilityBar />;
}
